export { default } from './Description';
export {
  getHeadings,
  getPlainTextContent,
  checkDescriptionIsNotEmpty,
  replaceMarkersInDescription,
} from './Description.utils';
